var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dms-check',_vm._b({attrs:{"indeterminate":_vm.isIndeterminate},on:{"update:value":_vm.updateValue}},'dms-check',Object.assign({}, _vm.$props, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }